export const FORM_LABELS = {
  PLACEHOLDER_WORK_SELECTION: 'Sélectionnez vos travaux',
};
